import { Component } from '@angular/core';
import { Platform, ViewController, NavParams } from 'ionic-angular';
import { UserBankService } from '../../services/userbank.service';
import { AlertService } from '../../providers/alert.service';
import { StorageService } from '../../providers/storage.service';
import { UserModel } from '../../models/user.model';

@Component({
  selector: 'add-userbank',
  templateUrl: 'adduserbank.html',
  providers: [UserBankService]
})
export class AddUserBank {
  banklist = [];
  pros = [];
  pro = '_ALL';
  citys = [];
  city = '_ALL';
  areas = [];
  area = '_ALL';
  bank = {
    BankCode: "_ALL",
    BankNum: "",
    BankNumNew: "",
    BankUserName: "",
    UserName: this.storage.read<UserModel>("User").UserName,
    Province: "",
    BankUserPwd: ""
  };

  /** 判断是否USDT钱包类型 */
  bankType: string = null;
  msgStr = "银行卡号";

  tracks = {};
  constructor(private viewCtrl: ViewController,
    private navpar: NavParams,
    private userbankService: UserBankService,
    private alert: AlertService,
    private storage: StorageService,) {
    this.bankType = this.navpar.get("bankType");
    this.queryDrawBanks();
    this.proList();
    // this.subUserName = navpar.data.subUserName != undefined ? navpar.data.subUserName : "";
    // this.parentUserName = navpar.data.parentUserName != undefined ? navpar.data.parentUserName : "";

  }
  //获取提现银行列表
  // TQQ 2017-01-03
  queryDrawBanks() {
    let arr = [], usdt = [];
    this.userbankService.queryDrawBanks().then(s => {
      if (s) {
        s.forEach(item => {
          if (item.WalletType && item.WalletType != 'banks') {
            usdt.push(item);
          } else {
            arr.push(item);
          }
        });

        if (this.bankType == 'usdt') {
          this.banklist = usdt;
        } else {
          this.banklist = arr;
        }
      }

    });
  }

  //省列表
  //TQQ 2017-01-03
  proList() {
    this.userbankService.proList().then(s => {
      this.pros = s;
    });
  }

  //市列表
  //TQQ 2017-01-03
  cityList(procode: string) {
    this.city = "_ALL";
    this.userbankService.cityList(procode).then(s => {
      this.citys = s;
    });
  }

  //区列表
  //TQQ 2017-01-03
  areaList(cityCode: string) {
    this.area = "_ALL";
    this.userbankService.areaList(cityCode).then(s => {
      this.areas = s;
    });
  }

  //添加银行卡
  //TQQ 2017-01-03
  addUserBankOk() {
    if (this.bank.BankCode == "_ALL") {
      let str = this.bankType == 'usdt' ? '请选择钱包类型' : '请选择银行类型';
      this.alert.showAlert(str);
      return;
    }
    if (!this.bank.BankUserName && this.bankType != 'usdt') {
      this.alert.showAlert("请输入持卡人姓名");
      return;
    }
    if (!this.bankType) {
      if (this.pro == "_ALL") {
        this.alert.showAlert("请选择银行开户省");
        return;
      }
      if (this.city == "_ALL") {
        this.alert.showAlert("请选择银行开户市");
        return;
      }
      if (this.area == "_ALL") {
        this.alert.showAlert("请选择银行开户县");
        return;
      }

      if (!this.bank.BankNum) {
        this.alert.showAlert("请输入" + this.msgStr);
        return;
      }
      if (!this.bank.BankNumNew) {
        this.alert.showAlert("请再次输入" + this.msgStr);
        return;
      }
      var regExp = new RegExp(/^[0-9]{16,19}$/);
      if (!regExp.test(this.bank.BankNum)) {
        this.alert.showAlert(this.msgStr + "应该为16-19位");
        return;
      }
      if (this.bank.BankNum != this.bank.BankNumNew) {
        this.alert.showAlert("两次输入" + this.msgStr + "不同");
        return;
      }
      this.bank.Province = this.pros.find(s => s.ProvinceCode == this.pro).ProvinceName + "-" + this.citys.find(s => s.CityCode == this.city).CityName + "-" + this.areas.find(s => s.AreaCode == this.area).AreaName;
    }
    if (this.bankType === "usdt") {
      this.msgStr = "钱包地址";
    }
    if (!this.bank.BankNum) {
      this.alert.showAlert("请输入" + this.msgStr);
      return;
    }
    if (this.bankType === "usdt") {

      //非 USDT 类钱包（如 OKPay）仅允许数字和字母
      if (this.bank.BankCode.indexOf('USDT') == -1) {
        if (!/^[A-Za-z0-9]+$/.test(this.bank.BankNum)) {
          this.alert.showAlert("请确认钱包地址是否正确!");
          return;
        }
      }

      //非 OKPay 的钱包地址长度必须 ≥ 20
      if (this.bank.BankCode != 'OKPayW' && this.bank.BankNum.length < 20) {
        this.alert.showAlert("请确认USDT钱包格式是否正确！");
        return;
      }

      if (this.bank.BankCode == 'USDT') {
        if (!this.bank.BankNum || this.bank.BankNum.substring(0, 2) !== "0x") {
          this.alert.showAlert("USDT-ERC20钱包必须以 0x 开头！");
          return;
        }
      }
      if (this.bank.BankCode == 'USDT-TRC20') {
        if (this.bank.BankNum.substring(0, 1) != "T") {
          this.alert.showAlert("USDT-TRC20钱包必须以 T 开头！");
          return;
        }
      }
    }









    if (!this.bank.BankNumNew) {
      this.alert.showAlert("请再次输入" + this.msgStr);
      return;
    }

    if (this.bank.BankNum != this.bank.BankNumNew) {
      this.alert.showAlert("两次输入" + this.msgStr + "不一样，请重新输入！");
      return;
    }
    if (!this.bank.BankUserPwd) {
      this.alert.showAlert('请输入资金密码');
      return;
    }

    this.userbankService.addUserBank(this.bank).then(s => {
      if (s.Result) {
        const getUserBanksInput = { pageIndex: 1, pageSize: 30 };
        this.userbankService.getUserBanks(getUserBanksInput.pageIndex, getUserBanksInput.pageSize).then((s: any) => {
          this.storage.write('userBanksCache', s);
        })
        this.viewCtrl.dismiss(s);
      } else {
        this.alert.showAlert(s.Error);
      }
    });

  }

  //关闭
  //TQQ 2017-01-03
  dismiss(data?: any) {
    this.viewCtrl.dismiss(data);
  }
}




// WEBPACK FOOTER //
// ./src/pages/userbanks/adduserbank.ts